import {
  Controller,
  FieldValues,
  FieldPath,
  useFormContext,
} from "react-hook-form";

import NumberField from "./NumberField";
import {
  NumberFieldHookFormProps,
  NumberFieldProps,
} from "./NumberField.types";

const NumberFieldHookForm = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  name,
  defaultValue,
  rules,
  shouldUnregister,
  setPropsWithFormState,
  ...innerProps
}: NumberFieldHookFormProps<TFieldValues, TName>) => {
  const { control } = useFormContext<TFieldValues>();
  return (
    <Controller
      name={name}
      defaultValue={defaultValue}
      rules={rules}
      shouldUnregister={shouldUnregister}
      control={control}
      render={(formState) => {
        const {
          field: { disabled, ref, onChange, ...innerField },
          formState: { errors },
        } = formState;
        const error = errors[name];
        const errorMsg = error?.message;
        const helperText =
          typeof errorMsg === "string" ? errorMsg : innerProps?.helperText;
        return (
          <NumberField
            {...innerProps}
            {...innerField}
            inputRef={ref}
            error={!!error}
            helperText={helperText}
            disabled={
              typeof disabled === "boolean" ? disabled : innerProps.disabled
            }
            onChange={onChange as NumberFieldProps["onChange"]}
            {...(setPropsWithFormState?.(formState) ?? {})}
          />
        );
      }}
    />
  );
};

export default NumberFieldHookForm;
